/**
 * Mine — a one-touch instakill dot (Brief 014 P1). N++'s mines: a small round hazard
 * that kills outright on contact (a SPIKE that is lethal, not a single-heart hit).
 *
 * A non-solid OVERLAP entity with a small centered hitbox. Routes lethal contact through
 * ctx.killPlayer (the full-reset respawn path LAVA uses), unless `props.instakill:false`
 * downgrades it to a one-heart hurt.
 *
 * Determinism: static, no motion/random/transcendentals → ESLint-clean.
 */
import type { Entity, EntityContext } from '../Entity';
import { EntityType } from '../LevelFormat';
import type { AABB } from '../TileGrid';

export class Mine implements Entity {
  readonly type = EntityType.MINE;
  body: AABB;
  vx = 0;
  vy = 0;
  facing: 1 | -1 = 1;
  alive = true;

  private instakill: boolean;

  /** @param props `instakill` (default true → death; false → one heart). */
  constructor(cx: number, feetY: number, props: Record<string, unknown> | undefined, _ts: number) {
    // Small round-ish footprint (28²) centered in the cell, resting near the floor.
    const s = 28;
    this.body = { x: cx - s / 2, y: feetY - s - 4, w: s, h: s };
    this.instakill = props?.instakill !== false;
  }

  update(_dt: number, _ctx: EntityContext): void { /* static */ }

  onPlayerOverlap(ctx: EntityContext): void {
    // POLISH_03 #10: starBlocks:true — the identical mine with instakill:false is blocked by
    // hurtPlayer's invulnSteps check, so the instakill:true variant should read the same to a
    // player holding a star (was silently piercing it before).
    if (this.instakill) ctx.killPlayer(true);
    else ctx.hurtPlayer();
  }

  spriteKey(): string { return 'mine'; }
  visible(): boolean { return true; }
}
